"use client";

import { useStore } from "@/hooks/system/useStore";
import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { ApiNews } from "@/api/news";
import { NewsListResourceData } from "@/api/generated-api";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useNewsData = () => {
  const [newsList, setNewsList] = useState<NewsListResourceData[]>([]);

  const searchParams = useSearchParams();

  const { setSelectedFilters, selectedFilters } = useStore("news");

  useEffect(() => {
    const page_number = searchParams.get("page_number") || 1;

    setSelectedFilters({
      pageNumber: +page_number,
    });
  }, [searchParams, setSelectedFilters]);

  const {
    data: news,
    isFetching,
    isPending,
  } = useLocalizedQuery({
    queryKey: ["news", selectedFilters.pageNumber],
    queryFn: async lang => ApiNews.getNews(lang, { pageNumber: selectedFilters.pageNumber }),
  });

  useEffect(() => {
    setNewsList(prev => (selectedFilters.showMore ? [...prev, ...(news?.data ?? [])] : [...(news?.data ?? [])]));
  }, [news, selectedFilters.pageNumber, selectedFilters.showMore]);

  return {
    news,
    newsLoading: isPending || (isFetching && !news),
    newsList,
  };
};
